
import { mapGetters } from 'vuex'

export default {
    data() {
        return {}
    },
    computed: {
        ...mapGetters(['vip', 'uname']),
    },
    created() {},
    methods: {
        get_home_page() {
            alert('浏览器不支持此操作, 请手动设为首页')
        },
        get_collection() {
            alert(
                '加入收藏失败，请使用Ctrl+D进行添加,或手动在浏览器里进行设置.'
            )
        },
        getsign_in() {
            this.$router.push('/login/')
        },
        handleLogout() {
            this.$router.push('/login/')
            this.$store.dispatch('Logout')
        },
    },
}
